import { render, staticRenderFns } from "./VehicleClassPerformance.vue?vue&type=template&id=6a0a6b28&"
import script from "./VehicleClassPerformance.vue?vue&type=script&lang=js&"
export * from "./VehicleClassPerformance.vue?vue&type=script&lang=js&"
import style0 from "./VehicleClassPerformance.vue?vue&type=style&index=0&id=6a0a6b28&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports